<template>
	<Menu
		:items="items"
		@click.stop.prevent
		@select="$emit('select', $event)"
		bottom
		:localize="localize"
		ref="menu"
	>
		<div class="actions">
			<EllipsisIcon vertical type="regular" />
		</div>
		<template v-if="$slots.item" #item="{ item, index }">
			<slot name="item" :item="item" :index="index" />
		</template>
	</Menu>
</template>

<script>
import { Menu } from '@/components/common'
import { EllipsisIcon } from '@/icons'

export default {
	name: 'DotsMenu',
	components: { Menu, EllipsisIcon },
	props: { items: Array, localize: { type: Boolean, default: null } },
	emits: ['select'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.actions {
	cursor: pointer;
	padding: 6px;
	font-size: 16px;
	@include flex-center;
	border-radius: 6px;
	&:hover {
		background: rgba($pronto-blue, 0.2);
	}
}
:deep(.popover-trigger) {
	&.open {
		.actions {
			background: rgba($pronto-blue, 0.2);
		}
	}
}
</style>
